// ************************************************************
// Start Global BYO Chill Tips Bundles Vars + Utility Functions
// ************************************************************
let byo_bundle_data = {
    name: 'BYO Chill Tips Bundle',
    slug: 'byo-chill-tips-bundle/e628b873-f3ff-4b19-af3c-4484ab47c8dc',
    id: '42226018418741',
    size: '6',
    selling_plan_id: ''
}

let right_arrow_svg = `<svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
</svg>
`

let byo_line_items = {};

let image_html = $('#byo-product-images').html();
let byo_product_images = JSON.parse(image_html);

function _updatePlanPricing() {
    let $standalone = $('.byo-chill-tips-action').find('.bundle-action-standalone');
    let $recurring = $('.byo-chill-tips-action').find('.bundle-action-recurring');

    let $standalone_input = $standalone.find('input');

    let $bundle_atc = $('.byo-chill-tips-action').find('.bundle-action-atc');

    let bundle_id = byo_bundle_data.id;

    console.log('update pricing?')

    if (bundle_id === '42226018385973') {
        $standalone.find('.byo-selling-plan-price').html(`
        <span class="strike-through">$48</span>
        <span>$45</span>
        `)

        $recurring.find('.byo-selling-plan-price').html(`
        <span class="strike-through">$45</span>
        <span>$40</span>
        `)

        if ($standalone_input.is(':checked')) {
            $bundle_atc.find('.bundle-action-atc-price').empty().html('$45');
        } else {
            $bundle_atc.find('.bundle-action-atc-price').empty().html('$40');
        }

    } else if (bundle_id === '42226018418741') {
        $standalone.find('.byo-selling-plan-price').html(`
        <span class="strike-through">$64</span>
        <span>$58</span>
        `)

        $recurring.find('.byo-selling-plan-price').html(`
        <span class="strike-through">$58</span>
        <span>$52</span>
        `)

        if ($standalone_input.is(':checked')) {
            $bundle_atc.find('.bundle-action-atc-price').empty().html('$58');
        } else {
            $bundle_atc.find('.bundle-action-atc-price').empty().html('$52');
        }
    } else if (bundle_id === '42226018451509') {
        $standalone.find('.byo-selling-plan-price').html(`
        <span class="strike-through">$80</span>
        <span>$70</span>
        `)

        $recurring.find('.byo-selling-plan-price').html(`
        <span class="strike-through">$70</span>
        <span>$63</span>
        `)

        if ($standalone_input.is(':checked')) {
            $bundle_atc.find('.bundle-action-atc-price').empty().html('$70');
        } else {
            $bundle_atc.find('.bundle-action-atc-price').empty().html('$63');
        }
    }
}

function _renderProducts(products, selector) {
    let to_render = ``;
    let product_count = 0;
    let collection_has_variants = false;

    products.sort(function(a,b){
        if (a.variants[0].available && !b.variants[0].available) {
            return -1;
          } else if (!a.variants[0].available && b.variants[0].available) {
            return 1;
          }
          return 0;
    })
  
    products.map((product) => {
        let product_title = product.title;
        let product_id = product.id;
        let product_url = `/products/${product.handle}`;

        let image_src = product.images['0'].src;

        if (product.tags.indexOf('nobyob') >= 0 || product.tags.indexOf('Bundles') >= 0 || product.handle === 'chill-stix') {
            return false;
        }

        let product_image_badge = '';

        if (product.tags.indexOf('oft') >= 0) {
            product_image_badge = `<div class="byo-product-badge"><img src="https://cdn.shopify.com/s/files/1/0023/1836/8821/files/OFT2024_RGB_FINAL.png?v=1729900770" alt="Oprah's Favorite Things Badge 2024"/></div>`
        }

        product_count++;

        if (product.variants.length > 1) {

            collection_has_variants = true;

            let first_available_variant_id = false;
            let first_available_variant_title = ``;

            let product_select = '';

            let dropdown_options = ``;

            product.variants.map((variant, index) => {
                let variant_id = variant.id;

                if (!first_available_variant_id && variant.available) {
                    first_available_variant_id = variant.id;
                    first_available_variant_title = variant.title;
                }

                if (!variant.available) {
                    product_select += `
                    <div class="byo-product-select disabled hidden" data-variant-id="${variant.id}" data-product-title="${product_title}: ${variant.title}">
                    <div class="byo-product-atc disabled">OUT OF STOCK</div>
                    </div>
                    `;
                } else {
                    product_select += `
                    <div class="byo-product-select ${ variant.id === first_available_variant_id ? '' : 'hidden'}" data-variant-id="${variant.id}" data-product-title="${product_title}: ${variant.title}">
                    <div class="byo-product-atc">ADD TO BUNDLE</div>
                    <div class="byo-shop-quantity-select">
                        <button class="shop-quantity-button shop-quantity-dec">-</button>
                        <input readonly type="number" id="quantity-${variant_id}" name="quantity" value="1" min="1">
                        <button class="shop-quantity-button shop-quantity-inc">+</button>
                    </div>
                    </div>
                    `;
                }

                dropdown_options += `
                <option value="${variant_id}" ${variant_id === first_available_variant_id ? 'selected' : ''}>${ variant.title }</option>
                `

            });

                if (!first_available_variant_id) {
                    product_select += `
                    <div class="byo-product-select disabled">
                    <div class="byo-product-atc disabled">OUT OF STOCK</div>
                    </div>
                    `;
                }

                let variant_dropdown = `<select id="${product_id}-select">${dropdown_options}</select>`

                to_render += `
                <div class="byo-shop-product" data-product-id="${product_id}" data-variant-id="${first_available_variant_id}" data-thumbnail-src="${image_src}" data-product-title="${product_title}: ${first_available_variant_title}" data-product-tags="${ product.tags.join('|')}">
                    <a class="byo-product-image view-details">
                        <img src="${image_src}" alt="Image of ${product_title} press on tips product" />
                        ${product_image_badge}
                    </a>
                    <div class="byo-product-rating-price">
                        <div class="byo-product-rating">
                            <svg width="87" height="17" viewBox="0 0 87 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.91931 13.4311C8.05247 13.3465 8.22253 13.3465 8.35569 13.4311L12.3397 15.9622C12.6453 16.1564 13.0333 15.8846 12.9551 15.531L11.8868 10.6956C11.8554 10.5534 11.9023 10.4053 12.0099 10.3072L15.5924 7.04081C15.8539 6.80241 15.7074 6.36692 15.3551 6.33494L10.6718 5.90984C10.5198 5.89604 10.3882 5.7983 10.3312 5.6567L8.51489 1.14911C8.37799 0.809362 7.89701 0.809362 7.76011 1.14911L5.94381 5.6567C5.88675 5.7983 5.75523 5.89604 5.6032 5.90984L0.919951 6.33494C0.567559 6.36692 0.421124 6.80241 0.682596 7.04081L4.26506 10.3072C4.37267 10.4053 4.41964 10.5534 4.38822 10.6956L3.31986 15.531C3.24174 15.8846 3.62971 16.1564 3.93534 15.9622L7.91931 13.4311Z" fill="#FF9C81"/>
                            <path d="M25.5502 13.431C25.6833 13.3464 25.8534 13.3464 25.9865 13.431L29.9705 15.9621C30.2762 16.1563 30.6641 15.8845 30.586 15.5309L29.5176 10.6955C29.4862 10.5533 29.5332 10.4052 29.6408 10.3071L33.2233 7.04068C33.4847 6.80228 33.3383 6.3668 32.9859 6.33481L28.3027 5.90972C28.1506 5.89592 28.0191 5.79817 27.9621 5.65658L26.1457 1.14898C26.0089 0.80924 25.5279 0.80924 25.391 1.14898L23.5747 5.65658C23.5176 5.79817 23.3861 5.89592 23.2341 5.90972L18.5508 6.33481C18.1984 6.3668 18.052 6.80228 18.3135 7.04069L21.8959 10.3071C22.0035 10.4052 22.0505 10.5533 22.0191 10.6955L20.9507 15.5309C20.8726 15.8845 21.2606 16.1563 21.5662 15.9621L25.5502 13.431Z" fill="#FF9C81"/>
                            <path d="M43.181 13.431C43.3142 13.3464 43.4842 13.3464 43.6174 13.431L47.6014 15.9621C47.907 16.1563 48.295 15.8845 48.2169 15.5309L47.1485 10.6955C47.1171 10.5533 47.164 10.4052 47.2717 10.3071L50.8541 7.04068C51.1156 6.80228 50.9692 6.3668 50.6168 6.33481L45.9335 5.90972C45.7815 5.89592 45.65 5.79817 45.5929 5.65658L43.7766 1.14898C43.6397 0.80924 43.1587 0.80924 43.0218 1.14898L41.2055 5.65658C41.1485 5.79817 41.017 5.89592 40.8649 5.90972L36.1817 6.33481C35.8293 6.3668 35.6828 6.80228 35.9443 7.04069L39.5268 10.3071C39.6344 10.4052 39.6814 10.5533 39.6499 10.6955L38.5816 15.5309C38.5035 15.8845 38.8914 16.1563 39.1971 15.9621L43.181 13.431Z" fill="#FF9C81"/>
                            <path d="M60.8138 13.431C60.947 13.3464 61.1171 13.3464 61.2502 13.431L65.2342 15.9621C65.5398 16.1563 65.9278 15.8845 65.8497 15.5309L64.7813 10.6955C64.7499 10.5533 64.7969 10.4052 64.9045 10.3071L68.4869 7.04068C68.7484 6.80228 68.602 6.3668 68.2496 6.33481L63.5663 5.90972C63.4143 5.89592 63.2828 5.79817 63.2257 5.65658L61.4094 1.14898C61.2725 0.80924 60.7915 0.80924 60.6546 1.14898L58.8383 5.65658C58.7813 5.79817 58.6498 5.89592 58.4977 5.90972L53.8145 6.33481C53.4621 6.3668 53.3157 6.80228 53.5771 7.04069L57.1596 10.3071C57.2672 10.4052 57.3142 10.5533 57.2828 10.6955L56.2144 15.5309C56.1363 15.8845 56.5242 16.1563 56.8299 15.9621L60.8138 13.431Z" fill="#FF9C81"/>
                            <path d="M78.4447 13.431C78.5779 13.3464 78.7479 13.3464 78.8811 13.431L82.865 15.9621C83.1707 16.1563 83.5587 15.8845 83.4805 15.5309L82.4122 10.6955C82.3808 10.5533 82.4277 10.4052 82.5353 10.3071L86.1178 7.04068C86.3793 6.80228 86.2328 6.3668 85.8804 6.33481L81.1972 5.90972C81.0452 5.89592 80.9136 5.79817 80.8566 5.65658L79.0403 1.14898C78.9034 0.80924 78.4224 0.80924 78.2855 1.14898L76.4692 5.65658C76.4121 5.79817 76.2806 5.89592 76.1286 5.90972L71.4453 6.33481C71.093 6.3668 70.9465 6.80228 71.208 7.04069L74.7905 10.3071C74.8981 10.4052 74.945 10.5533 74.9136 10.6955L73.8453 15.5309C73.7671 15.8845 74.1551 16.1563 74.4607 15.9621L78.4447 13.431Z" fill="#FF9C81"/>
                            </svg>
                        </div>
                        <span class="byo-product-price">$${product.variants[0].price}</span>
                    </div>
                    <span class="byo-product-title rich-text__heading">${product_title}</span>
                    <div class="byo-product-action">
                        ${ product_select }
                        <div class="byo-product-variant-select">${ !first_available_variant_id ? '': variant_dropdown }</div>
                    </div>
                    <div class="view-details" data-handle="${product.handle}"><span data-handle="${product.handle}">View Details ${right_arrow_svg}</span></div>
                </div>
                `;
        } else {
            let variant_id = product.variants[0].id;

            let product_select = '';

            if (!product.variants[0].available) {
                product_select = `
                <div class="byo-product-select disabled" data-variant-id="${variant_id}">
                <div class="byo-product-atc disabled">OUT OF STOCK</div>
                </div>
                `;
            } else {
                product_select = `
                <div class="byo-product-select" data-variant-id="${variant_id}">
                <div class="byo-product-atc">ADD TO BUNDLE</div>
                <div class="byo-shop-quantity-select">
                    <button class="shop-quantity-button shop-quantity-dec">-</button>
                    <input readonly type="number" id="quantity-${variant_id}" name="quantity" value="1" min="1">
                    <button class="shop-quantity-button shop-quantity-inc">+</button>
                </div>
                </div>
                `;
            }

            to_render += `
            <div class="byo-shop-product" data-product-id="${product_id}" data-variant-id="${variant_id}" data-thumbnail-src="${image_src}" data-product-title="${product_title}" data-product-tags="${ product.tags.join('|')}">
                <a class="byo-product-image view-details">
                    <img src="${image_src}" alt="Image of ${product_title} press on tips product" />
                    ${product_image_badge}
                </a>
                <div class="byo-product-rating-price">
                    <div class="byo-product-rating">
                        <svg width="87" height="17" viewBox="0 0 87 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.91931 13.4311C8.05247 13.3465 8.22253 13.3465 8.35569 13.4311L12.3397 15.9622C12.6453 16.1564 13.0333 15.8846 12.9551 15.531L11.8868 10.6956C11.8554 10.5534 11.9023 10.4053 12.0099 10.3072L15.5924 7.04081C15.8539 6.80241 15.7074 6.36692 15.3551 6.33494L10.6718 5.90984C10.5198 5.89604 10.3882 5.7983 10.3312 5.6567L8.51489 1.14911C8.37799 0.809362 7.89701 0.809362 7.76011 1.14911L5.94381 5.6567C5.88675 5.7983 5.75523 5.89604 5.6032 5.90984L0.919951 6.33494C0.567559 6.36692 0.421124 6.80241 0.682596 7.04081L4.26506 10.3072C4.37267 10.4053 4.41964 10.5534 4.38822 10.6956L3.31986 15.531C3.24174 15.8846 3.62971 16.1564 3.93534 15.9622L7.91931 13.4311Z" fill="#FF9C81"/>
                        <path d="M25.5502 13.431C25.6833 13.3464 25.8534 13.3464 25.9865 13.431L29.9705 15.9621C30.2762 16.1563 30.6641 15.8845 30.586 15.5309L29.5176 10.6955C29.4862 10.5533 29.5332 10.4052 29.6408 10.3071L33.2233 7.04068C33.4847 6.80228 33.3383 6.3668 32.9859 6.33481L28.3027 5.90972C28.1506 5.89592 28.0191 5.79817 27.9621 5.65658L26.1457 1.14898C26.0089 0.80924 25.5279 0.80924 25.391 1.14898L23.5747 5.65658C23.5176 5.79817 23.3861 5.89592 23.2341 5.90972L18.5508 6.33481C18.1984 6.3668 18.052 6.80228 18.3135 7.04069L21.8959 10.3071C22.0035 10.4052 22.0505 10.5533 22.0191 10.6955L20.9507 15.5309C20.8726 15.8845 21.2606 16.1563 21.5662 15.9621L25.5502 13.431Z" fill="#FF9C81"/>
                        <path d="M43.181 13.431C43.3142 13.3464 43.4842 13.3464 43.6174 13.431L47.6014 15.9621C47.907 16.1563 48.295 15.8845 48.2169 15.5309L47.1485 10.6955C47.1171 10.5533 47.164 10.4052 47.2717 10.3071L50.8541 7.04068C51.1156 6.80228 50.9692 6.3668 50.6168 6.33481L45.9335 5.90972C45.7815 5.89592 45.65 5.79817 45.5929 5.65658L43.7766 1.14898C43.6397 0.80924 43.1587 0.80924 43.0218 1.14898L41.2055 5.65658C41.1485 5.79817 41.017 5.89592 40.8649 5.90972L36.1817 6.33481C35.8293 6.3668 35.6828 6.80228 35.9443 7.04069L39.5268 10.3071C39.6344 10.4052 39.6814 10.5533 39.6499 10.6955L38.5816 15.5309C38.5035 15.8845 38.8914 16.1563 39.1971 15.9621L43.181 13.431Z" fill="#FF9C81"/>
                        <path d="M60.8138 13.431C60.947 13.3464 61.1171 13.3464 61.2502 13.431L65.2342 15.9621C65.5398 16.1563 65.9278 15.8845 65.8497 15.5309L64.7813 10.6955C64.7499 10.5533 64.7969 10.4052 64.9045 10.3071L68.4869 7.04068C68.7484 6.80228 68.602 6.3668 68.2496 6.33481L63.5663 5.90972C63.4143 5.89592 63.2828 5.79817 63.2257 5.65658L61.4094 1.14898C61.2725 0.80924 60.7915 0.80924 60.6546 1.14898L58.8383 5.65658C58.7813 5.79817 58.6498 5.89592 58.4977 5.90972L53.8145 6.33481C53.4621 6.3668 53.3157 6.80228 53.5771 7.04069L57.1596 10.3071C57.2672 10.4052 57.3142 10.5533 57.2828 10.6955L56.2144 15.5309C56.1363 15.8845 56.5242 16.1563 56.8299 15.9621L60.8138 13.431Z" fill="#FF9C81"/>
                        <path d="M78.4447 13.431C78.5779 13.3464 78.7479 13.3464 78.8811 13.431L82.865 15.9621C83.1707 16.1563 83.5587 15.8845 83.4805 15.5309L82.4122 10.6955C82.3808 10.5533 82.4277 10.4052 82.5353 10.3071L86.1178 7.04068C86.3793 6.80228 86.2328 6.3668 85.8804 6.33481L81.1972 5.90972C81.0452 5.89592 80.9136 5.79817 80.8566 5.65658L79.0403 1.14898C78.9034 0.80924 78.4224 0.80924 78.2855 1.14898L76.4692 5.65658C76.4121 5.79817 76.2806 5.89592 76.1286 5.90972L71.4453 6.33481C71.093 6.3668 70.9465 6.80228 71.208 7.04069L74.7905 10.3071C74.8981 10.4052 74.945 10.5533 74.9136 10.6955L73.8453 15.5309C73.7671 15.8845 74.1551 16.1563 74.4607 15.9621L78.4447 13.431Z" fill="#FF9C81"/>
                        </svg>
                    </div>
                    <span class="byo-product-price">$${product.variants[0].price}</span>
                </div>
                <span class="byo-product-title rich-text__heading">${product_title}</span>
                <div class="byo-product-action">
                    ${ product_select }
                </div>
                <div class="view-details" data-handle="${product.handle}"><span data-handle="${product.handle}">View Details ${right_arrow_svg}</span></div>
            </div>
            `
        }
    });

    $(selector).find('.products-wrapper').empty().html(to_render);

    // REDESIGN 2024
    // if (product_count > 10) {
    //     $(selector).find('.see-more-wrap').empty().html('<div class="see-more-button"><button class="color-background-3 button button--primary">SEE ALL</button</div>');
    // }

    if (collection_has_variants) {
        $(selector).find('.products-wrapper').addClass('has-variants');
    }

    $(selector).removeClass('loading');
}

function _renderShopSection() {
    $('.byo-shop-products-container').find('.collection-wrapper').addClass('loading');
    $('.byo-shop-products-container').find('.collection-wrapper').find('.products-wrapper').empty();

    $.getJSON('/collections/byo-chill-tips-bundle/products.json?limit=250', function(response) {
        console.log('get products response?', response);
        _renderProducts(response.products, '#byo-chill-tips-bundle');
    });

    // 2024 REDESIGN
    // $.getJSON('/collections/chill-tips-best-sellers/products.json?limit=250', function(response) {
    //     console.log('get products response?', response);
    //     _renderProducts(response.products, '#byo-tips-best-sellers');

    //     $.getJSON('/collections/the-signatures/products.json?limit=250', function(response) {
    //         console.log('get products response?', response);
    //         _renderProducts(response.products, '#byo-tips-signatures');

    //         $.getJSON('/collections/the-simples/products.json?limit=250', function(response) {
    //             console.log('get products response?', response);
    //             _renderProducts(response.products, '#byo-tips-simples');

    //             $.getJSON('/collections/the-limited-1/products.json?limit=250', function(response) {
    //                 console.log('get products response?', response);
    //                 _renderProducts(response.products, '#byo-tips-limited');
    //             });
    //         });
    //     });
    // });
}

async function _dataViewDetails(handle){

  /*$.getJSON(`/products/${handle}.json`, function(response){
    console.log(response)
    const title = document.querySelector(".view-details-modal .content .product__title")
    const description = document.querySelector(".view-details-modal .content .product__description")
    const reviews = document.querySelector(".view-details-modal .content .reviews-stars")
    const featuredImage= document.querySelector(".view-details-modal .content .featured-image")
    title.textContent = response.product.title;
    description.innerHTML = response.product.body_html;
    featuredImage.innerHTML = `<img src="${response.product.image.src}" alt="${response.product.image.alt}"/>`
    const widgetElement = document.querySelector('[data-oke-star-rating]');
    window.okeWidgetApi.setProduct(widgetElement, `shopify-${response.product.id}`)

  }) */
    _clearDetailsModal();
    _toggleViewDetails();
    _toggleDetailsLoading();
  const response = await fetch(`/products/${handle}?view=byo-view-details`, {
  
}).then(res => res.text());

const html = new DOMParser().parseFromString(response, 'text/html')
 
  const container = document.querySelector(".product-content")
  const content = html.querySelector('.section').innerHTML
  container.innerHTML = content;
  _toggleDetailsLoading();
  
}

function _clearDetailsModal(){
  const container = document.querySelector(".product-content")
    container.innerHTML = ""
}

function _toggleViewDetails(){
  const modal = document.querySelector(".view-details-modal")
  modal.classList.toggle('active')
}

function _toggleDetailsLoading(){
    const modal = document.querySelector(".modal-content");
    modal.classList.toggle('loading');
}

function _renderByoCartItemsHeader() {
    let max = parseInt(byo_bundle_data.size);
    let items_count = Object.keys(byo_line_items).length;
    let total_quantity = 0;

    if (items_count > 0) {
        total_quantity = _getTotalQuantity();
    }

    $('.bundle-action-progress').html(`YOUR BUNDLE (${total_quantity}/${max})`);
}

function _renderByoCartItems() {
    let max = 6;
    // REDESIGN 2024
    // let max = parseInt(byo_bundle_data.size);
    let items_count = Object.keys(byo_line_items).length;
    let total_quantity = 0;

    if (items_count > 0) {
        total_quantity = _getTotalQuantity();
    }

    let to_render = ``;

    if (items_count > 0) {
        let item_keys = Object.keys(byo_line_items);

        let item_index = 1;

        item_keys.forEach((key) => {
            let item_data = byo_line_items[key];
            let item_quantity = item_data.quantity;

            for (let i = 0; i < item_quantity; i++) {
                let earnings_badge = '';

                if ($('#bodyElement').hasClass('auto-discount-enabled')) {
                    if (item_index >= 3 && item_index === total_quantity) {
                        earnings_badge = `
                        <div class="bundle-action-badge">
                        <span>Earning 20% off</span>
                        </div>
                        `
                    }
                } else {
                    if (item_index === 3 && item_index === total_quantity) {
                        earnings_badge = `
                        <div class="bundle-action-badge">
                        <span>Earning 15% off</span>
                        </div>
                        `
                    } else if (item_index === 4 && item_index === total_quantity) {
                        earnings_badge = `
                        <div class="bundle-action-badge">
                        <span>Earning 17% off</span>
                        </div>
                        `
                    } else if (item_index === 5 && item_index === total_quantity) {
                        earnings_badge = `
                        <div class="bundle-action-badge">
                        <span>Earning 20% off</span>
                        </div>
                        `
                    } else if (item_index === 6 && item_index === total_quantity) {
                        earnings_badge = `
                        <div class="bundle-action-badge">
                        <span>Earning 25% off</span>
                        </div>
                        `
                    }
                }

                to_render += `
                <div class="bundle-action-cart-product active" data-product-id="${key}" data-variant-id="${key}">
                    <div class="product-remove">
                        <svg class="product-remove-mobile-svg" width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.779528 11.0866L0 10.3071L4.73491 5.54331L0 0.779528L0.779528 0L5.51444 4.76378L10.2205 0L11 0.779528L6.26509 5.54331L11 10.3071L10.2205 11.0866L5.51444 6.35171L0.779528 11.0866Z" fill="white"/>
                        </svg>
                    </div>
                    <div class="product-image" style="background-image: url('${item_data.image_src}')">${earnings_badge}</div>
                    <span class="product-title">${item_data.title}</span>
                </div>
                `;

                item_index ++;
            }
        })
    }

    let empty_cells_count = max - total_quantity;

    if (empty_cells_count > 0) {
        // REDESIGN 2024
        let empty_index = total_quantity;

        for (let i = 0; i < empty_cells_count; i++) {

            let empty_content = '<span>+</span>';

            if ($('#bodyElement').hasClass('auto-discount-enabled')) {
                if (empty_index >= 2) {
                    empty_content = '<span><em>20%</em></span><span>Off</span>'
                }
            } else {
                if (empty_index === 2) {
                    empty_content = '<span><em>15%</em></span><span>Off</span><span style="text-align: center;font-size: 12px;">+ free shipping!</span>';
                } else if (empty_index === 3) {
                    empty_content = '<span><em>17%</em></span><span>Off</span><span style="text-align: center;font-size: 12px;">+ free shipping!</span>'
                } else if (empty_index === 4) {
                    empty_content = '<span><em>20%</em></span><span>Off</span><span style="text-align: center;font-size: 12px;">+ free shipping!</span>'
                } else if (empty_index === 5) {
                    empty_content = '<span><em>25%</em></span><span>Off</span><span style="text-align: center;font-size: 12px;">+ free shipping!</span>'
                }
            }

            to_render += `
            <div class="bundle-action-cart-product empty">
                <div class="product-remove">+</div>
                <div class="product-image" style="background-image: url('https://cdn.shopify.com/s/files/1/0023/1836/8821/files/byo_redesign_empty_cell_off_white.png?v=1742588045')">
                    <div class="product-image-empty-content">${empty_content}</div>
                </div>
                <span class="product-title"></span>
            </div>
            `;

            empty_index++;
        }
    }

    _renderByoCartItemsHeader()
    $('.bundle-action-cart').empty().html(to_render);
    $('.bundle-action-cart-mobile').empty().html(to_render);
}

function _handleAddToCartStatus() {
    let $atc = $('.byo-chill-tips-action').find('.bundle-action-atc');
    let $mobile_atc = $('.byo-chill-tips-action-mobile').find('.bundle-action-atc-static');

    let max = parseInt(byo_bundle_data.size);
    let items_count = Object.keys(byo_line_items).length;
    let total_quantity = 0;

    if (items_count > 0) {
        total_quantity = _getTotalQuantity();
    } else {
        $('.bundle-action-bottomline-price').html(`$0.00 - Add More To Save`);
        $('.bundle-action-savings-price').html(`$0.00`);
        $('.bundle-action-bottomline-compare').html('');

        $atc.html('ADD MORE TO SAVE');
        $mobile_atc.html('ADD MORE TO SAVE');
        $atc.prop("disabled", true);
        $mobile_atc.prop("disabled", true);
        return false;
    }

    if (total_quantity >= 3) {
        let byo_product_data = JSON.parse(document.getElementById('byo-product-data').textContent);
        if ($('#bodyElement').hasClass('auto-discount-enabled')) {
            if (total_quantity === 3) {
                let byo_automatic_discount = byo_product_data['CHBYOB3'].variant_price * 0.2;
                let byo_discount = byo_product_data['CHBYOB3'].variant_price - byo_automatic_discount;

                $('.bundle-action-bottomline-price').html(`$${byo_discount.toFixed(2)} + Free Shipping!`);
                $('.bundle-action-bottomline-compare').html(`$${byo_product_data['CHBYOB3'].variant_compare_at_price.toFixed(2)}`);
                $('.bundle-action-savings-price').html(`$${(byo_product_data['CHBYOB3'].variant_compare_at_price - byo_discount).toFixed(2)}`);
            } else if (total_quantity === 4) {
                let byo_automatic_discount = byo_product_data['CHBYOB4'].variant_price * 0.2;
                let byo_discount = byo_product_data['CHBYOB4'].variant_price - byo_automatic_discount;

                $('.bundle-action-bottomline-price').html(`$${byo_discount.toFixed(2)} + Free Shipping!`);
                $('.bundle-action-bottomline-compare').html(`$${byo_product_data['CHBYOB4'].variant_compare_at_price.toFixed(2)}`);
                $('.bundle-action-savings-price').html(`$${(byo_product_data['CHBYOB4'].variant_compare_at_price - byo_discount).toFixed(2)}`);
            } else if (total_quantity === 5) {
                let byo_automatic_discount = byo_product_data['CHBYOB5'].variant_price * 0.2;
                let byo_discount = byo_product_data['CHBYOB5'].variant_price - byo_automatic_discount;

                $('.bundle-action-bottomline-price').html(`$${byo_discount.toFixed(2)} + Free Shipping!`);
                $('.bundle-action-bottomline-compare').html(`$${byo_product_data['CHBYOB5'].variant_compare_at_price.toFixed(2)}`);
                $('.bundle-action-savings-price').html(`$${(byo_product_data['CHBYOB5'].variant_compare_at_price - byo_discount).toFixed(2)}`);
            } else if (total_quantity === 6) {
                let byo_automatic_discount = byo_product_data['CHBYOB6'].variant_price * 0.2;
                let byo_discount = byo_product_data['CHBYOB6'].variant_price - byo_automatic_discount;

                $('.bundle-action-bottomline-price').html(`$${byo_discount.toFixed(2)} + Free Shipping!`);
                $('.bundle-action-bottomline-compare').html(`$${byo_product_data['CHBYOB6'].variant_compare_at_price.toFixed(2)}`);
                $('.bundle-action-savings-price').html(`$${(byo_product_data['CHBYOB6'].variant_compare_at_price - byo_discount).toFixed(2)}`);
            }
        } else {
            if (total_quantity === 3) {
                $('.bundle-action-bottomline-price').html(`$${byo_product_data['CHBYOB3'].variant_price.toFixed(2)} + Free Shipping!`);
                $('.bundle-action-bottomline-compare').html(`$${byo_product_data['CHBYOB3'].variant_compare_at_price.toFixed(2)}`);
                $('.bundle-action-savings-price').html(`$${(byo_product_data['CHBYOB3'].variant_compare_at_price - byo_product_data['CHBYOB3'].variant_price).toFixed(2)}`);
            } else if (total_quantity === 4) {
                $('.bundle-action-bottomline-price').html(`$${byo_product_data['CHBYOB4'].variant_price.toFixed(2)} + Free Shipping!`);
                $('.bundle-action-bottomline-compare').html(`$${byo_product_data['CHBYOB4'].variant_compare_at_price.toFixed(2)}`);
                $('.bundle-action-savings-price').html(`$${(byo_product_data['CHBYOB4'].variant_compare_at_price - byo_product_data['CHBYOB4'].variant_price).toFixed(2)}`);
            } else if (total_quantity === 5) {
                $('.bundle-action-bottomline-price').html(`$${byo_product_data['CHBYOB5'].variant_price.toFixed(2)} + Free Shipping!`);
                $('.bundle-action-bottomline-compare').html(`$${byo_product_data['CHBYOB5'].variant_compare_at_price.toFixed(2)}`);
                $('.bundle-action-savings-price').html(`$${(byo_product_data['CHBYOB5'].variant_compare_at_price - byo_product_data['CHBYOB5'].variant_price).toFixed(2)}`);
            } else if (total_quantity === 6) {
                $('.bundle-action-bottomline-price').html(`$${byo_product_data['CHBYOB6'].variant_price.toFixed(2)} + Free Shipping!`);
                $('.bundle-action-bottomline-compare').html(`$${byo_product_data['CHBYOB6'].variant_compare_at_price.toFixed(2)}`);
                $('.bundle-action-savings-price').html(`$${(byo_product_data['CHBYOB6'].variant_compare_at_price - byo_product_data['CHBYOB6'].variant_price).toFixed(2)}`);
            }
        }

        $atc.html('ADD BUNDLE TO CART');
        $mobile_atc.html('ADD BUNDLE TO CART');
        $atc.prop("disabled", false);
        $mobile_atc.prop("disabled", false);
    } else {
        $('.bundle-action-bottomline-price').html(`$${(total_quantity * 16).toFixed(2)} - Add More To Save`);
        $('.bundle-action-savings-price').html(`$0.00`);
        $('.bundle-action-bottomline-compare').html('');

        $atc.html('ADD MORE TO SAVE');
        $mobile_atc.html('ADD MORE TO SAVE');
        $atc.prop("disabled", true);
        $mobile_atc.prop("disabled", true);
    }
}

function _filterByoProductsByTags() {
    let active_tags = [];

    $(`.collection-wrapper`).addClass('loading');
    $(`.collection-wrapper`).removeClass('empty');

    $(`#bundle-tag-filters-desktop button[data-tag]`).each(function(index) {
        if ($(this).hasClass('active')) {
            active_tags.push($(this).data('tag'));
        }
    })

    if (!active_tags.length) {
        $(`.byo-shop-product`).removeClass('hidden').removeClass('filtered');
        $(`.collection-wrapper`).removeClass('loading');
        return false;
    }

    $(`.byo-shop-product`).addClass('hidden').addClass('filtered');
    $('.see-more-button').addClass('hidden');

    active_tags.map(function(tag) {
        $(`.byo-shop-product[data-product-tags*="${tag}"]`).removeClass('hidden').removeClass('filtered');
    });

    $('.collection-wrapper').each(function(index) {
        let active_products = $(this).find('.products-wrapper').children('.byo-shop-product:not(.hidden)');

        if (!active_products.length) {
            $(this).addClass('empty');
        }
    })

    $(`.collection-wrapper`).removeClass('loading');
}

function _getTotalQuantity() {
    let item_keys = Object.keys(byo_line_items);
    let quantity = 0;

    item_keys.forEach((key) => {
        quantity += byo_line_items[key].quantity;
    })

    return quantity;
}

function initBuildYourOwn() {

    let $chill_stix_element = $('.byo-chill-tips-main[data-chill-stix="true"');

    if ($chill_stix_element.length) {
        console.log('Chill stix detected');

        byo_line_items['43807927599157'] = {
            variant_id: '43807927599157',
            title: 'Chill Stix',
            image_src: 'https://cdn.shopify.com/s/files/1/0023/1836/8821/files/Untitleddesign_23.png?v=1722610948',
            quantity: 1
        }

    } else {
        console.log('Chill stix not detected');
    }

    _renderShopSection();
    _renderByoCartItems();
}

initBuildYourOwn();

// **********************
// Global Event Listeners
// **********************

$('.byo-chill-tips-size-select').on('click', '.option-select', function(event) {
    let $selected = $(event.target).closest('button');
    let $options = $(event.target).closest('.size-select-options');

    let bundle_id = $selected.attr('data-bundle-id');
    let bundle_size = $selected.attr('data-bundle-size');

    $options.find('.option-block').removeClass('active');
    $options.find('.option-select').html('<span>SELECT</span>');

    $selected.closest('.option-block').addClass('active');
    $selected.html('<span>BUILD YOUR BUNDLE!</span>');

    byo_bundle_data.id = bundle_id;
    byo_bundle_data.size = bundle_size;

    byo_line_items = {};

    _updatePlanPricing();
    _renderShopSection();
    _renderByoCartItems();
})

$('.byo-bundle-size-select').on('click', 'label', function(event) {

    let $container = $(event.target).closest('.size-select-container');
    let $display = $container.find('.display');
    let $selected = $(event.target).closest('label');

    let bundle_id = $selected.attr('data-bundle-id');
    let bundle_size = $selected.attr('data-bundle-size');

    $display.find('.bundle-size-option').removeClass('active');
    $display.find(`.bundle-size-option[data-option-type="${bundle_size}-pack"]`).addClass('active');

    $container.removeClass('expanded');

    byo_bundle_data.id = bundle_id;
    byo_bundle_data.size = bundle_size;

    byo_line_items = {};

    _updatePlanPricing();
    _renderShopSection();
    _renderByoCartItems();
})

$('.byo-shop-products-container').on('change', 'select', function(event) {
    let select_value = this.value;
    let $product = $(event.target).closest('.byo-shop-product');
    let $select_atc = $product.find(`.byo-product-select[data-variant-id="${select_value}"]`);
    let variant_title = $select_atc.attr('data-product-title');

    $product.attr('data-variant-id', select_value);
    $product.attr('data-product-title', variant_title);
    $product.find('.byo-product-select').addClass('hidden');
    $product.find(`.byo-product-select[data-variant-id="${select_value}"]`).removeClass('hidden');
})

$('.bundle-tag-filters').on('change', 'select', function(event) {
        let tag = $('#mobile-filter-select').find(":selected").val();
        $(`button[data-tag]`).removeClass('active');
        $(`button[data-tag="${tag}"]`).toggleClass('active');
        _filterByoProductsByTags();
})

$('.byo-chill-tips-shop').on('click', '.byo-product-atc', function(event) {

    let $atc = $(event.target).closest('.byo-product-atc');

    if ($atc.hasClass('disabled')) {
        return false;
    }

    let $selected = $(event.target).closest('.byo-shop-product');

    let product_id = $selected.attr('data-product-id');
    let product_variant_id = $selected.attr('data-variant-id');
    let product_title = $selected.attr('data-product-title');
    let product_img_src = $selected.attr('data-thumbnail-src');

    let max = parseInt(byo_bundle_data.size);
    let items_count = Object.keys(byo_line_items).length;
    let total_quantity = 0;

    if (items_count > 0) {
        total_quantity = _getTotalQuantity();
    }

    if (total_quantity >= max) {
        return false;
    }

    byo_line_items[product_variant_id] = {
        variant_id: product_variant_id,
        title: product_title,
        image_src: product_img_src,
        quantity: 1
    }

    $selected.find(`.byo-product-select[data-variant-id="${product_variant_id}"]`).addClass('added');

    _renderByoCartItems();
    _handleAddToCartStatus();
})

$('#byo-custom').on('click', '.byo-modal-product-atc', function(event) {

    let $atc = $(event.target).closest('.byo-modal-product-atc');

    if ($atc.hasClass('disabled')) {
        return false;
    }

    let $modal_select = $(event.target).closest('.byo-modal-product-select');
    let modal_product_id = $modal_select.attr('data-product-id');

    let $selected = $('.byo-chill-tips-shop').find(`.byo-shop-product[data-product-id="${modal_product_id}"]`);

    let is_added = $selected.find('.byo-product-select').hasClass('added');

    if (is_added) {
        let $button = $selected.find('.shop-quantity-inc');
    
        let product_id = $selected.attr('data-product-id');
        let product_variant_id = $selected.attr('data-variant-id');
        let product_title = $selected.attr('data-product-title');
        let product_img_src = $selected.attr('data-thumbnail-src');
    
        let $quantity_input = $selected.find(`#quantity-${product_variant_id}`);
    
        let max = parseInt(byo_bundle_data.size);
        let items_count = Object.keys(byo_line_items).length;
        let total_quantity = 0;
    
        if (items_count > 0) {
            total_quantity = _getTotalQuantity();
        }

            if (total_quantity >= max) {
                return false;
            }
    
            let current_quantity = byo_line_items[product_variant_id].quantity;
        
            byo_line_items[product_variant_id] = {
                variant_id: product_variant_id,
                title: product_title,
                image_src: product_img_src,
                quantity: current_quantity + 1
            }
    
            $quantity_input.val(byo_line_items[product_variant_id].quantity);
    
        $('#byo-custom').find('.close-modal').trigger('click');
        _renderByoCartItems();
        _handleAddToCartStatus();
    } else {
        let product_id = $selected.attr('data-product-id');
        let product_variant_id = $selected.attr('data-variant-id');
        let product_title = $selected.attr('data-product-title');
        let product_img_src = $selected.attr('data-thumbnail-src');
    
        let max = parseInt(byo_bundle_data.size);
        let items_count = Object.keys(byo_line_items).length;
        let total_quantity = 0;
    
        if (items_count > 0) {
            total_quantity = _getTotalQuantity();
        }
    
        if (total_quantity >= max) {
            return false;
        }
    
        byo_line_items[product_variant_id] = {
            variant_id: product_variant_id,
            title: product_title,
            image_src: product_img_src,
            quantity: 1
        }
    
        $selected.find(`.byo-product-select[data-variant-id="${product_variant_id}"]`).addClass('added');
    
        $('#byo-custom').find('.close-modal').trigger('click');
        _renderByoCartItems();
        _handleAddToCartStatus();
    }
})

$('.byo-chill-tips-shop').on('click', '.see-more-button', function(event) {
    let $button = $(event.target).closest('.see-more-button');
    let $products = $(event.target).closest('.collection-wrapper').find('.products-wrapper');
    $products.find('.byo-shop-product').removeClass('hidden');
    $button.addClass('hidden');
})

$('.byo-chill-tips-shop').on('click', '.shop-quantity-button', function(event) {
    let $button = $(event.target).closest('button');
    let $selected = $(event.target).closest('.byo-shop-product');

    let product_id = $selected.attr('data-product-id');
    let product_variant_id = $selected.attr('data-variant-id');
    let product_title = $selected.attr('data-product-title');
    let product_img_src = $selected.attr('data-thumbnail-src');

    let $quantity_input = $selected.find(`#quantity-${product_variant_id}`);

    let max = parseInt(byo_bundle_data.size);
    let items_count = Object.keys(byo_line_items).length;
    let total_quantity = 0;

    if (items_count > 0) {
        total_quantity = _getTotalQuantity();
    }

    if ($button.hasClass('shop-quantity-inc')) {
        if (total_quantity >= max) {
            return false;
        }

        let current_quantity = byo_line_items[product_variant_id].quantity;
    
        byo_line_items[product_variant_id] = {
            variant_id: product_variant_id,
            title: product_title,
            image_src: product_img_src,
            quantity: current_quantity + 1
        }

        $quantity_input.val(byo_line_items[product_variant_id].quantity);

    } else if ($button.hasClass('shop-quantity-dec')) {
        let current_quantity = byo_line_items[product_variant_id].quantity;

        if (current_quantity <= 1) {
            delete byo_line_items[product_variant_id]
            $selected.find(`.byo-product-select[data-variant-id="${product_variant_id}"]`).removeClass('added');
        } else {
            byo_line_items[product_variant_id] = {
                variant_id: product_variant_id,
                title: product_title,
                image_src: product_img_src,
                quantity: current_quantity - 1
            }
            $quantity_input.val(byo_line_items[product_variant_id].quantity);
        }
    } else {
        return false;
    }

    _renderByoCartItems();
    _handleAddToCartStatus();
});

$('.bundle-action-cart').on('click', '.product-remove', function(event) {
    let $selected = $(event.target).closest('.bundle-action-cart-product');
    let product_id = $selected.attr('data-product-id');
    let variant_id = $selected.attr('data-variant-id')

    let current_quantity = byo_line_items[variant_id].quantity;
    let $shop_product_cell = $('.byo-shop-products-container').find(`.byo-shop-product[data-variant-id=${variant_id}]`);

    if (current_quantity <= 1) {
        delete byo_line_items[variant_id];
        $shop_product_cell.find(`.byo-product-select[data-variant-id="${variant_id}"]`).removeClass('added');
    } else {
        let product = byo_line_items[variant_id];

        byo_line_items[variant_id] = {
            variant_id: product.variant_id,
            title: product.title,
            image_src: product.image_src,
            quantity: current_quantity - 1
        }
        $shop_product_cell.find(`#quantity-${product_id}`).val(byo_line_items[variant_id].quantity);
    }

    _renderByoCartItems();
    _handleAddToCartStatus();
});

$('.byo-bundle-size-select').on('click', '.display', function(event) {
    event.stopPropagation();
    $(event.target).closest('.size-select-container').toggleClass('expanded');
});

$('.bundle-tag-filter').on('click', '.bundle-tag-filter-button', function(event) {
    $button = $(event.target).closest('.bundle-tag-filter').find('button');
    let tag = $button.data('tag');
    console.log('byo bundle tag filter clicked:', tag);

    $(`button[data-tag="${tag}"]`).toggleClass('active');

    _filterByoProductsByTags();
});

$('.mobile-filter-select').on('change', function() {
    let tag = $('.mobile-filter-select').find(":selected").val();
    $(`button[data-tag]`).removeClass('active');
    $(`button[data-tag="${tag}"]`).toggleClass('active');
    _filterByoProductsByTags();
});

$('.byo-chill-tips-action').on('click', '.bundle-action-container', function(event) {
    let $action = $(event.target).closest('.byo-chill-tips-action');

    if ($action.hasClass('expanded')) {
        return false;
    }

    $action.toggleClass('expanded');
});

$('.byo-chill-tips-action').on('click', '.bundle-action-mobile-control', function(event) {
    let $action = $(event.target).closest('.byo-chill-tips-action');

    $action.toggleClass('expanded');
});

$('.byo-chill-tips-action').on('click', '.bundle-action-progress', function(event) {
    let $action = $(event.target).closest('.byo-chill-tips-action');

    $action.toggleClass('expanded');
});

$('.byo-chill-tips-action').on('click', 'label', function(event) {
    event.preventDefault();

    let $form = $(event.target).closest('.bundle-action-form');
    let $label_wrap = $(event.target).closest('.bundle-action-label-wrap');

    let $input = $(event.target).closest('label').find('input');

    $form.find('.bundle-action-label-wrap').removeClass('active');
    $label_wrap.addClass('active');
    $input.prop("checked", true);

    _updatePlanPricing();
});

$('.byo-chill-tips-action').on('click', '.bundle-quantity-button', function(event) {
    event.preventDefault();

    let $button = $(event.target).closest('button');
    let $quantity_input = $(event.target).closest('.bundle-action-submit').find('#quantity-bundle');
    let current_quantity = parseInt($quantity_input.val());

    if ($button.hasClass('bundle-quantity-inc')) {
        $quantity_input.val(current_quantity + 1);
    } else if ($button.hasClass('bundle-quantity-dec')) {
        if (current_quantity > 1) {
            $quantity_input.val(current_quantity - 1);
        }
    } else {
        return false;
    }
});

$('.byo-shop-products-container').on('click', '.view-details', function(event){
  let $parent = $(event.target).closest('.byo-shop-product');
  let $view_details = $parent.find('div.view-details');
  let handle = $view_details.attr('data-handle');
  _dataViewDetails(handle)
});

$('body').on('click', '.view-details-modal', function(event) {
    if(!$(event.target).closest('.modal-content').length) {
        _toggleViewDetails()
        _clearDetailsModal()
    }
});
document.querySelector(".close-modal").addEventListener("click", function(){
  _toggleViewDetails()
  _clearDetailsModal()
});

$('.byo-chill-tips-action-mobile').on('click', '.bundle-action-atc-static', function(event) {
    event.preventDefault();
    $('.bundle-action-atc')[0].click();
});

$('.byo-chill-tips-action').on('click', '.bundle-action-atc', function(event) {
    event.preventDefault();

    let $form = $(event.target).closest('form');

    // 2024 REDESIGN
    // let selling_plan_type = $form.find('input[name=selling_plan_type]:checked').val();

    let selling_plan_type = 'one-time';
    let selling_plan_id = selling_plan_type === 'one-time' ? '' : $form.find('select[name=selling_plan_id]').val();

    let quantity = parseInt($form.find('input[name=bundle_quantity]').val());

    let items_count = Object.keys(byo_line_items).length;
    let total_quantity = 0;

    if (items_count > 0) {
        total_quantity = _getTotalQuantity();
    }

    let bundle_id = false;

    if (total_quantity === 3) {
        bundle_id = '42226018385973';
    } else if (total_quantity === 4) {
        bundle_id = '42226018418741';
    } else if (total_quantity === 5) {
        bundle_id = '42226018451509';
    } else if (total_quantity === 6) {
        bundle_id = '44031210258485';
    }

    if (!bundle_id) {
        return false;
    }

    let bundle_item = {};

    let smartrr_bundle_info = {
        items: [],
        date: new Date().getTime(),
        page: window.location.toString(),
        bundle: {
            name: byo_bundle_data.name,
            slug: byo_bundle_data.slug
        }
    };

    bundle_item = {
        id: bundle_id,
        quantity,
        selling_plan: selling_plan_id,
        properties: {
            Bundle: byo_bundle_data.name
        }
    }

    let line_items = Object.keys(byo_line_items);

    line_items.forEach((item) => {
        let product_data = byo_line_items[item];

        smartrr_bundle_info.items.push({
            id: product_data.variant_id,
            quantity: product_data.quantity,
            selling_plan: selling_plan_id
        })

        bundle_item.properties[product_data.title] = product_data.quantity;
    })

    let smartrr_bundle_info_json = JSON.stringify(smartrr_bundle_info);

    bundle_item.properties['_smartrr_info'] = smartrr_bundle_info_json;

    let atc_payload = {
        items: [bundle_item]
    }

    console.log('payload?', atc_payload);

    fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(atc_payload),
      }).then(function () {
        console.log('BYO chill tips bundle ATC success');
      });
});

$('body').on('click', '.bundle-action-cart-product.empty', function() {
    let $byo_shop_section = $('.byo-shop-products-container');
    let byo_shop_offset = $byo_shop_section[0].offsetTop;
    // console.log('?', $byo_shop_section);
    $('html, body').animate({scrollTop : byo_shop_offset},360);
});

/* Observer for sticky ATC */
const targetElement = document.querySelector('.byo-chill-tips-action-mobile');
const options = {
  root: null,
  rootMargin: '0px',
  threshold: 0 // Trigger when the target enters or exits the viewport
};
const callback = function(entries, observer) {
  entries.forEach(entry => {
    if (!entry.isIntersecting && entry.boundingClientRect.y < 0) {
      document.body.classList.add('sticky-byo-cart-active');
    } else {
      document.body.classList.remove('sticky-byo-cart-active');
    }
  });
};
const observer = new IntersectionObserver(callback, options);
observer.observe(targetElement);
